module.exports = __webpack_public_path__ + "static/img/newsdd.f50f82e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsdd.png
// module id = S+N7
// module chunks = 45